module.exports = __webpack_public_path__ + "img/Isotipo.6035a42c.png";